import { useRef, useState } from "react";

const UserAppAccessReadOnlyRow = ({ key, t, appAccessItem, handleDeleteClick, oddIdx,
	add, setError, fidesRoles, factbookRoles, fairRoles, idirtRoles, cristalRoles, handleSubmit }) => {
	const [editFlag, setEditFlag] = useState(false);
	const [appRoles, setAppRoles] = useState({});
	const [appRole, setAppRole] = useState(appAccessItem.appRole);
	const [subscriptionDate, setSubscriptionDate] = useState(appAccessItem.subscriptionDate);
	const today = new Date().toISOString().split("T")[0];
	const roleRef = useRef(null);
	const subscriptionDateRef = useRef(null);
	const [isSubmit, setIsSubmit] = useState(false);

	const onEdit = () => {
		if (add) {
			setError(t("error.newRowAdded"));
		} else {
			setEditFlag(true);
			if (appAccessItem.appName === "Fides") {
				setAppRoles(fidesRoles);
			} else if (appAccessItem.appName === "Factbook") {
				setAppRoles(factbookRoles);
			} else if (appAccessItem.appName === "FAIR") {
				setAppRoles(fairRoles);
			} else if (appAccessItem.appName === "iDirt") {
				setAppRoles(idirtRoles);
			} else if (appAccessItem.appName === "Cristal") {
				setAppRoles(cristalRoles);
			} else {
				setAppRoles({});
			}
		}
	}
	function appRoleHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		let selectedAppRole = e.target.value;
		setAppRole(selectedAppRole);
	}
	function subscriptionDateHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		let selectedSubscriptionDate = e.target.value;
		setSubscriptionDate(selectedSubscriptionDate);
	}
	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		setAppRole(roleRef.current.value);
		setSubscriptionDate(subscriptionDateRef.current.value);
		let initialValues = {
			appName: appAccessItem.appName,
			appRole: roleRef.current.value,
			subscriptionDate: subscriptionDateRef.current.value
		};

		if (!appAccessItem.appName || !appRole) {
			setError(t("error.appName.appRole.Reqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(2, initialValues, submitComplete);
		}

	}
	
	function submitDelete(event, appAccessItem){
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, appAccessItem, submitComplete);
	}
	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{appAccessItem.appDisplayName}</td>
			{editFlag ?
				<>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
						<select id="appRole" onChange={(e) => (appRoleHandler(e))} value={appRole} ref={roleRef} className="form-select" style={{ minWidth: "150px" }}>
							{appRoles.length > 0 && appRoles.map((appRoleObj, index2) => (
								<option
									value={appRoleObj.roleCode}
								>
									{appRoleObj.description}
								</option>
							))}
						</select>
					</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
						<input
							type="date"
							name="subscriptionDate"
							id="subscriptionDate"
							value={subscriptionDate || today}
							className="form-control rounded-pill shadow-sm px-4 "
							ref={subscriptionDateRef}
							onChange={(e) => (subscriptionDateHandler(e))}
							style={{ maxWidth: "250px" }}
						/>
					</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{appAccessItem.status}</td>
					<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
						<div id="submit-spinner"
							className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
						>
						</div>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (setEditFlag(false))}>{t("page.cancel")}</button>
					</td>
				</>
				:
				<>
					<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{appAccessItem.appRoleDescription}</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{appAccessItem.subscriptionDate}</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{appAccessItem.status}</td>
					<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block me-4"} 
							onClick={(event) => onEdit(event)}>{t("page.edit")}</button>
						<div id="submit-spinner"
							className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
						>
						</div>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"}  onClick={(event) => submitDelete(event, appAccessItem)}>
							{appAccessItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
					</td>
				</>
			}

		</tr>
	)
}
export default UserAppAccessReadOnlyRow;